type AmendmentAdvisor = {
  name?: string;
  phone?: string;
  email?: string;
};

type AmendmentAuthorizedSigner = {
  name?: string;
  phone?: string;
  email?: string;
};

type AmendmentChangeRequestNotes = {
  currentProvision?: string;
  requestedProvision?: string;
  notes?: string;
  intentionOfChange?: string;
  affectedParty?: string;
};

type ResponsibleParty = {
  idType: string;
  userId: string;
};

export enum AmendmentsProvisions {
  COMPANY_INFORMATION = 'Company Information',
  GENERAL_INFORMATION = 'General Information',
  ELIGIBILITY_AND_OR_ENTRY_DATE = 'Eligibility And/Or Entry Date',
  AUTO_ENROLL___ADD_REMOVE = 'Auto-Enroll - Add/Remove',
  CONTRIBUTIONS___DEFERRAL_AND_SAFE_HARBOR = 'Contributions - Deferral And Safe Harbor',
  CONTRIBUTIONS___MATCHING_OR_NON_ELECTIVE = 'Contributions - Matching Or Non-Elective',
  VESTING = 'Vesting',
  DISTRIBUTIONS = 'Distributions',
  VESTING_OVERRIDES = 'Vesting Overrides',
  IN_SERVICE_WITHDRAWALS = 'In-Service Withdrawals',
  PARTICIPATING_EMPLOYER___ADD_REMOVE_EDIT = 'Participating Employer - Add/Remove/Edit',
  CUSTOM_EFFECTIVE_DATE_AND_CUSTOM_LANGUAGE = 'Custom Effective Date And Custom Language',
  LOAN_POLICY_UPDATE = 'Loan Policy Update',
  TPA_SUBMISSION = 'Tpa Submission',
  ADD_LOANS = 'Add Loans'
}

export enum AmendmentsBilling {
  DISCOUNTED_FEE = '$250 - Discounted Fee',
  GENERAL_AMENDMENT_FEE = '$350 - General Amendment Fee',
  JPM_WILL_COVER_FEE = '$350 - JPM Will Cover Fee',
  COMPEX_AMENDMENT_FEE = '$500+ - Compex Amendment Fee',
  INTERNAL_MERGER_FEE = '$750 - Internal Merger Fee',
  EXTERNAL_MERGER_FEE = '$1200 - External Merger Fee',
  WAIVED___FEE_INCLUDED_IN_CONVERSION = 'Waived - Fee Included In Conversion',
  WAIVED___ADDRESS_CHANGE = 'Waived - Address Change',
  WAIVED___CLIENT_OR_FA_RELATIONSHIP = 'Waived - Client Or FA Relationship',
  WAIVED___OTHER__ADD_TO_DESCRIPTION = 'Waived - Other, Add To Description',
  WAIVED___TPA_SUBMISSION = 'Waived - TPA Submission',
  WAIVED___LOAN_POLICY_CHANGE = 'Waived - Loan Policy Change',
  WAIVED___VW_ERROR = 'Waived - VW Error'
}

export type GetAmendmentsRecordResponseDto = {
  adminStatus: string;
  advisor: AmendmentAdvisor;
  authorizedSigner: AmendmentAuthorizedSigner;
  billing: string;
  changeRequestNotes: AmendmentChangeRequestNotes;
  createdAt: string;
  createdBy: ResponsibleParty;
  desiredEffectiveDate: string;
  id: number;
  isFeeWaiverCompleted: boolean;
  isPsaChangeNeeded: boolean;
  isSubmitted: boolean;
  productTierId: number;
  provisions: AmendmentsProvisions[];
  sponsorPlanId: number;
  status: string;
  updatedAt: string;
  updatedBy: ResponsibleParty;
  assignee: string;
};

export type UpdateAmendmentsRecordBody = {
  id: number;
  status?: string;
  isSubmitted?: boolean;
};

export type UpdateAmendmentsRecordResponseDto = {
  id: number;
  status: string;
  isSubmitted: boolean;
  updatedAt: string;
  updatedBy: ResponsibleParty;
};
